var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 37.5V7.5C2 6.17392 2.52678 4.90215 3.46447 3.96447C4.40215 3.02678 5.67392 2.5 7 2.5H34.5M2 37.5C2 36.1739 2.52678 34.9021 3.46447 33.9645C4.40215 33.0268 5.67392 32.5 7 32.5H9.5M2 37.5C2 38.8261 2.52678 40.0979 3.46447 41.0355C4.40215 41.9732 5.67392 42.5 7 42.5H9.5M52 42.5H24.5C23.1739 42.5 21.9021 43.0268 20.9645 43.9645C20.0268 44.9021 19.5 46.1739 19.5 47.5M19.5 47.5C19.5 48.8261 20.0268 50.0979 20.9645 51.0355C21.9021 51.9732 23.1739 52.5 24.5 52.5H50.75C51.0815 52.5 51.3995 52.3683 51.6339 52.1339C51.8683 51.8995 52 51.5815 52 51.25V13.75C52 13.4185 51.8683 13.1005 51.6339 12.8661C51.3995 12.6317 51.0815 12.5 50.75 12.5H24.5C23.1739 12.5 21.9021 13.0268 20.9645 13.9645C20.0268 14.9021 19.5 16.1739 19.5 17.5V47.5Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.68df9affa37f56b8c54347235cb6d9f4.svg";
export { ForwardRef as ReactComponent };